export default __webpack_public_path__ + "static/media/Roller conveyor chain drive.4d544c87.jpg";